import { Data, VerifyStrategy, VerifyStrategyFactoryMethod } from './types';

const getBody = (newStatus: boolean) => ({ is_active: newStatus });

export const getVerifyStrategyFactoryMethod = (
  type: string,
  statusName: 'fca_status' | 'lmc_status',
): VerifyStrategyFactoryMethod | never => {
  const map = {
    fca_status: (data: Data, newStatus: boolean): VerifyStrategy => ({
      endpoint: `/api/v1/broker-management/fca/activation/${data.fca_id}`,
      body: getBody(newStatus),
    }),
    lmc_status: (data: Data, newStatus: boolean): VerifyStrategy => ({
      endpoint: `/api/v1/broker-management/${type}/verify/${data.id}`,
      body: getBody(newStatus),
    }),
  };

  if (typeof map[statusName] === 'function') {
    return map[statusName];
  }

  throw new Error('Verification Strategy could not be created.');
};
